'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:RegisterCtrl
 * @description
 * # RegisterCtrl
 */
angular.module('360StoreAngularApp')
	.controller('RegisterCtrl', function ($scope, $location, api) { // Inject toastr

		$scope.registrationData = {
			email: null,
			password: null,
			passwordConfirm: null
		};

		$scope.doRegister = async () => {
			await api.registerUser($scope.registrationData);
			toastr.success('Your account has been created! Please check your email to verify your email address.', 'Account Created');
			$location.path('/login');
			$scope.registrationData = {};
		};
	});
